export const ProIcon = () => (
  <img src="/images/plusIcon.svg" alt="Pro" width={20} height={20} />
);

export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2 6V12.9333C2 13.3067 2 13.4933 2.07266 13.6359C2.13658 13.7613 2.23849 13.8635 2.36393 13.9274C2.5064 14 2.693 14 3.06564 14H10.0001M9.33333 8.66667V6.66667M9.33333 6.66667V4.66667M9.33333 6.66667H7.33333M9.33333 6.66667H11.3333M4.66667 9.20013V4.13346C4.66667 3.38673 4.66667 3.01308 4.81199 2.72786C4.93982 2.47698 5.14365 2.27316 5.39453 2.14532C5.67975 2 6.05339 2 6.80013 2H11.8668C12.6135 2 12.9867 2 13.2719 2.14532C13.5228 2.27316 13.727 2.47698 13.8548 2.72786C14.0001 3.01308 14.0001 3.38646 14.0001 4.13319L14.0001 9.19987C14.0001 9.94661 14.0001 10.32 13.8548 10.6052C13.727 10.8561 13.5228 11.0603 13.2719 11.1882C12.987 11.3333 12.6143 11.3333 11.869 11.3333H6.79794C6.05266 11.3333 5.67947 11.3333 5.39453 11.1882C5.14365 11.0603 4.93982 10.8561 4.81199 10.6053C4.66667 10.32 4.66667 9.94687 4.66667 9.20013Z"
      stroke="#111111"
      strokeOpacity="0.6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    className="shrink-0"
  >
    <g data-figma-bg-blur-radius="4">
      <rect width="30" height="30" rx="4" fill="white" fillOpacity="0.34" />
      <path
        d="M15 11.5488V15.4377M15 23.75C10.1675 23.75 6.25 19.8325 6.25 15C6.25 10.1675 10.1675 6.25 15 6.25C19.8325 6.25 23.75 10.1675 23.75 15C23.75 19.8325 19.8325 23.75 15 23.75ZM15.0484 18.3544V18.4516L14.9516 18.4512V18.3544H15.0484Z"
        stroke="#FC5132"
        strokeWidth="1.55556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="bgblur_0_205_4265_clip_path" transform="translate(4 4)">
        <rect width="30" height="30" rx="4" />
      </clipPath>
    </defs>
  </svg>
);
